var _a, _b;
import { bindActionCreators, configureStore } from '@reduxjs/toolkit';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { useMemo } from 'react';
import { config } from 'env_def';
import { storeOpRegister, apiHolder as api, locationHelper, inWindow, apis, getIn18Text, } from 'api';
import rootReducer, { AppActions, GlobalActions, AttachmentActions, ContactActions, TempContactActions, MailActions, ReadCountActions, ScheduleActions, MailConfigActions, MailTemplateActions, MailClassifyActions, DiskActions, DiskAttActions, StrangerActions, ReadMailActions, NiceModalActions, AutoReplyActions, MailProductActions, HollowOutGuideAction, MailTabActions, AiWriteMailReducer, SalesPitchActions, ConfigActions, HotKeysActions, NoticeCenterActions, AutoUnmountReducer, PopupActions, } from './reducer';
import { Thunks } from '@web-common/state/reducer/mailReducer';
import { resetMailWithDraft as resetMailWithDraftAsync } from '@web-mail-write/components/SendMail/utils';
import { FLOLDER, INIT_TASK_KEY, INIT_TASK_TIME_KEY, INIT_STATE_KEY, IMG_TYPES } from '@web-mail/common/constant';
import { folderIdIsAllFolderSubAccount, folderIdIsAllFolder } from '@web-mail/util';
import { actions } from '@web-common/popup_state';
import { putValueToDB } from '@web-common/popup_state/dbUtils';
import debounce from 'lodash/debounce';
import { loadScript, safeDecodeURIComponent, RDB_CLIENT_ID } from '@web-common/utils/utils';
import { tabId, tabType } from '@web-common/state/reducer/mailTabReducer';
import ImgPreview from '@web-common/components/UI/ImagePreview';
const eventApi = api.api.getEventApi();
const storageApi = api.api.getDataStoreApi();
const accountApi = api.api.requireLogicalApi(apis.accountApiImpl);
const systemApi = api.api.getSystemApi();
const debouncePutValueToDB = debounce(api => putValueToDB(api.getState().popupReducer.registeredPopUpWinMap), 500, { leading: false, trailing: true });
const debounceTriggerReducer = debounce((api, action) => {
    api.dispatch(action);
}, 500, { leading: false, trailing: true });
const middleware = api => next => action => {
    if (action.type === actions.registerNewWin.type || action.type === actions.loadLocalDataAndMerge.type) {
        console.log('[popup_state] openPopWinInOrder before ', action, api.getState().popupReducer);
    }
    const beforeState = api.getState();
    const response = next(action);
    const afterState = api.getState();
    if (action.type === actions.openPopWinInOrder.type ||
        action.type === actions.openOrCloseWin.type ||
        actions.cancel.type === action.type ||
        actions.closeWinWithPrefix.type === action.type) {
        console.log('[popup_state]  response', action, afterState.popupReducer);
        if (response) {
            debouncePutValueToDB(api);
        }
    }
    if (action.type === actions.registerNewWin.type || action.type === actions.cancel.type) {
        console.log('[popup_state] response ', action, afterState.popupReducer);
        debounceTriggerReducer(api, actions.openPopWinInOrder({}));
    }
    if (action.type == HollowOutGuideAction.doNextStep.type) {
        if (beforeState.hollowOutGuideReducer.guideQueue[0] && beforeState.hollowOutGuideReducer.guideQueue[0].guideId === action.payload.guideId) {
            if (action.payload.step >= beforeState.hollowOutGuideReducer.guideQueue[0].steps.length) {
                storageApi.put(action.payload.guideId, 'true', { noneUserRelated: beforeState.hollowOutGuideReducer.guideQueue[0].noneUserRelated });
            }
        }
    }
    if (action.type == HollowOutGuideAction.doSkip.type) {
        if (beforeState.hollowOutGuideReducer.guideQueue[0] && beforeState.hollowOutGuideReducer.guideQueue[0].guideId === action.payload.guideId) {
            storageApi.put(action.payload.guideId, 'true', { noneUserRelated: beforeState.hollowOutGuideReducer.guideQueue[0].noneUserRelated });
        }
    }
    if (action.type == HollowOutGuideAction.changeRemind.type) {
        storageApi.put(action.payload, 'true');
    }
    return response;
};
export const store = configureStore({
    reducer: rootReducer,
    middleware: getDefaultMiddleware => getDefaultMiddleware({ immutableCheck: false, serializableCheck: false }).concat(middleware),
    devTools: config('stage') !== 'prod',
});
export const useAppDispatch = () => useDispatch();
export const useAppSelector = useSelector;
export const userAppSelectorShallowEqual = shallowEqual;
export const useActions = (actions) => {
    const dispatch = useAppDispatch();
    return useMemo(() => bindActionCreators(actions, dispatch), [actions, dispatch]);
};
export { AppActions, GlobalActions, AttachmentActions, ContactActions, TempContactActions, MailActions, ReadCountActions, ScheduleActions, MailConfigActions, DiskActions, MailTemplateActions, MailClassifyActions, DiskAttActions, StrangerActions, ReadMailActions, NiceModalActions, AutoReplyActions, MailProductActions, HollowOutGuideAction, MailTabActions, AiWriteMailReducer, SalesPitchActions, ConfigActions, HotKeysActions, NoticeCenterActions, AutoUnmountReducer, PopupActions, };
if (process.env.BUILD_ISELECTRON && ((_b = (_a = window === null || window === void 0 ? void 0 : window.process) === null || _a === void 0 ? void 0 : _a.versions) === null || _b === void 0 ? void 0 : _b.electron) === '22.3.27') {
    function adjustForTimeZone(originalDate, date) {
        const currentTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        if (currentTimeZone === 'Africa/Cairo') {
            const gmtPlus3Offset = 3 * 60;
            const localOffset = date.getTimezoneOffset();
            return new originalDate(date.getTime() + (localOffset + gmtPlus3Offset) * 60000);
        }
        if (currentTimeZone === 'America/Mexico_City') {
            const gmtMinus5Offset = -6 * 60;
            const localOffset = date.getTimezoneOffset();
            return new originalDate(date.getTime() + (localOffset + gmtMinus5Offset) * 60000);
        }
        return date;
    }
    (function () {
        try {
            const originalDate = Date;
            function CustomDate(...args) {
                if (args.length === 0) {
                    return new originalDate();
                }
                else if (args.length === 1 && typeof args[0] === 'string') {
                    try {
                        const dateString = args[0];
                        const date = new originalDate(dateString);
                        return adjustForTimeZone(originalDate, date);
                    }
                    catch (e) {
                        return new originalDate(...args);
                    }
                }
                else {
                    return new originalDate(...args);
                }
            }
            CustomDate.prototype = originalDate.prototype;
            CustomDate.now = originalDate.now;
            CustomDate.parse = originalDate.parse;
            CustomDate.UTC = originalDate.UTC;
            window.Date = CustomDate;
            console.log('Date object has been hijacked to adjust Cairo timezone to GMT+3 on Electron 17.');
        }
        catch (e) {
            console.error('Date object hijack failed', e);
        }
    })();
}
try {
    if (process.env.BUILD_ISWEB) {
        let loadDebugTools = () => { };
        const key = 'LX_REMOTE_DEBUG_LOCAL_KEY';
        const GLOBAL_LX_REMOTE_DEBUG = '__LX__SNP__GLOBAL_REMOTE_DEBUG__';
        const REMOTE_DEBUG_URL = 'https://lingxi.office.163.com/rdbstatic/prodinject.v1.0.0.js';
        const channel = typeof BroadcastChannel !== 'undefined' ? new BroadcastChannel(GLOBAL_LX_REMOTE_DEBUG) : undefined;
        let recordReady = false;
        try {
            loadDebugTools = async () => {
                try {
                    if (window[GLOBAL_LX_REMOTE_DEBUG]) {
                        return window[GLOBAL_LX_REMOTE_DEBUG];
                    }
                    await loadScript(REMOTE_DEBUG_URL);
                    const tools = window[GLOBAL_LX_REMOTE_DEBUG];
                    tools.single('uiRecordStart', () => {
                        channel === null || channel === void 0 ? void 0 : channel.postMessage({
                            clientId: RDB_CLIENT_ID,
                            type: 'startRecord',
                            payload: {},
                        });
                    });
                    tools.single('uiCancelUpload', () => {
                        channel === null || channel === void 0 ? void 0 : channel.postMessage({
                            clientId: RDB_CLIENT_ID,
                            type: 'stopRecord',
                            payload: {},
                        });
                    });
                    tools.single('uiConfirmUpload', () => {
                        console.log('uiConfirmUpload');
                        channel === null || channel === void 0 ? void 0 : channel.postMessage({
                            clientId: RDB_CLIENT_ID,
                            type: 'stopRecordAndUpdate',
                            payload: {
                                taskId: RDB_CLIENT_ID,
                            },
                        });
                    });
                    tools.single('uiClose', () => {
                        channel === null || channel === void 0 ? void 0 : channel.postMessage({
                            clientId: RDB_CLIENT_ID,
                            type: 'closeTools',
                            payload: {},
                        });
                    });
                    return tools;
                }
                catch (e) {
                    console.log(e, '快照工具加载失败');
                    return null;
                }
            };
        }
        catch (e) {
            console.log('[Error]', e);
        }
        try {
            if (window) {
                const value = localStorage.getItem(key);
                if (value && loadDebugTools) {
                    loadDebugTools().then(tools => {
                        tools.verifyLocalConfig();
                    });
                }
            }
        }
        catch (e) {
            console.log('[Error]', e);
        }
        try {
            channel &&
                (channel.onmessage = async (event) => {
                    var _a, _b;
                    const message = event.data;
                    if (message.clientId === RDB_CLIENT_ID) {
                        return;
                    }
                    let tools = null;
                    try {
                        if (message.type === 'showRecord') {
                            const config = ((_a = message === null || message === void 0 ? void 0 : message.payload) === null || _a === void 0 ? void 0 : _a.config) || {};
                            tools = await loadDebugTools();
                            tools.setConfig(config);
                            tools.displayRecordingTools();
                        }
                        else if (message.type === 'startRecord') {
                            if (document.hasFocus()) {
                                tools = await loadDebugTools();
                                if (tools) {
                                    tools.displayRecordingTools({
                                        autoRecord: true,
                                    });
                                }
                            }
                            else {
                                recordReady = true;
                            }
                        }
                        else if (message.type === 'startRemote') {
                            tools = await loadDebugTools();
                            await tools.displayRemoteDebugToolsImplicit(message.payload.code, location.href);
                        }
                        else if (message.type === 'stopRemote') {
                            tools = await loadDebugTools();
                            tools === null || tools === void 0 ? void 0 : tools.closeRemoteDebug();
                        }
                        else if (message.type === 'stopRecord') {
                            tools = await loadDebugTools();
                            tools.resetRecordingTools();
                            recordReady = false;
                            tools = null;
                        }
                        else if (message.type === 'closeTools') {
                            tools = await loadDebugTools();
                            tools.closeRecordingTools();
                            tools.destroy();
                            recordReady = false;
                            tools = null;
                        }
                        else if (message.type === 'stopRecordAndUpdate') {
                            tools = await loadDebugTools();
                            const taskId = (_b = message === null || message === void 0 ? void 0 : message.payload) === null || _b === void 0 ? void 0 : _b.taskId;
                            tools.setConfig({
                                env: location.host + `[${taskId}]`,
                            });
                            await tools.stopRecordAndUpload();
                            recordReady = false;
                            tools = null;
                        }
                        else {
                            console.log('Unknown message type:', message.type);
                        }
                    }
                    catch (error) {
                        console.error('Error handling message:', error);
                        if (tools) {
                            tools.destroy();
                            tools = null;
                        }
                    }
                    try {
                        if (window && window.addEventListener) {
                            window.addEventListener('focus', async () => {
                                if (recordReady) {
                                    recordReady = false;
                                    tools = await loadDebugTools();
                                    if (tools) {
                                        tools.displayRecordingTools({
                                            autoRecord: true,
                                        });
                                    }
                                }
                            });
                        }
                    }
                    catch (e) {
                        console.log('[Error]', e);
                    }
                });
        }
        catch (e) {
            console.log('[Error]', e);
        }
    }
}
catch (e) {
    console.log('[Error]', e);
}
const pKey2IkeyMap = {
    fid: {
        type: 'mailReducer',
        keyPath: 'selectedKeys.id',
    },
    mid: {
        type: 'mailReducer',
        keyPath: 'selectedMailId.id',
    },
    fid_sd: {
        type: 'mailReducer',
        keyPath: 'selectedKeys_sd.id',
    },
};
const getSearch = (key) => {
    if (inWindow()) {
        const search = new URLSearchParams(window.location.search);
        return search.get(key) || '';
    }
    return '';
};
const switchParamsKey2InnerKey = (key) => {
    return pKey2IkeyMap[key];
};
const STORE_KEY = 'historyState';
export const getHistoryState = () => {
    if (localStorage) {
        const localState = localStorage.getItem(STORE_KEY);
        return localState ? JSON.parse(localState || '{}') : {};
    }
    return {};
};
export const removeKeyFromHistoryState = (key) => {
    try {
        if (localStorage) {
            const localState = localStorage.getItem(STORE_KEY);
            if (localState) {
                const stateObject = JSON.parse(localState);
                if (key in stateObject) {
                    delete stateObject[key];
                    localStorage.setItem(STORE_KEY, JSON.stringify(stateObject));
                }
            }
        }
    }
    catch (e) {
        console.error('removeKeyFromHistoryState', e);
    }
};
const getModule = () => {
    var _a;
    let module = {};
    try {
        if (inWindow()) {
            const hash = window.location.hash;
            const reg = /module=(\S*)/;
            const regVal = hash.match(reg);
            if (regVal) {
                module = JSON.parse((_a = safeDecodeURIComponent(regVal[0] || '')) === null || _a === void 0 ? void 0 : _a.replace(/(\S*)\|/, '')) || {};
            }
            else {
                module = JSON.parse((getLocalJumpParams('module') || '').replace(/(\S*)\|/, '') || '{}');
            }
        }
    }
    catch (e) {
        console.error('getModule', e);
    }
    return module;
};
const unifiedInitState = () => {
    try {
        const module = getModule();
        const fid = module === null || module === void 0 ? void 0 : module.fid;
        const state = getSearch(INIT_STATE_KEY);
        const stateMap = JSON.parse(state || '{}');
        return fid ? Object.assign(stateMap, { fid }) : stateMap;
    }
    catch (e) {
        console.error('[unifiedInitState error]', e);
        return {};
    }
};
const getLocalJumpParams = (key) => {
    try {
        const localMap = getHistoryState();
        if (localMap[key] != null && key != 'module') {
            try {
                removeKeyFromHistoryState(key);
            }
            catch (e) {
                console.error('removeKeyFromHistoryState', e);
            }
        }
        return localMap[key];
    }
    catch (e) {
        console.error('getLocalJumpParams', e);
    }
};
const unifiedInitTask = () => {
    try {
        let taskList = [];
        const module = getModule();
        const mid = getSearch('mid') || (module === null || module === void 0 ? void 0 : module.mid) || getLocalJumpParams('mid');
        if (mid) {
            taskList.push({ type: 'readMailTab', id: mid });
            return JSON.stringify(taskList);
        }
        const task = getSearch(INIT_TASK_KEY);
        if (task) {
            taskList = JSON.parse(task) || [];
            if (taskList.length > 0) {
                return JSON.stringify(taskList);
            }
        }
        return '';
    }
    catch (e) {
        console.error('[unifiedInitTask error]', e);
        return '';
    }
};
if (process.env.BUILD_ISWEB && inWindow()) {
    try {
        const stateMap = unifiedInitState();
        if (Object.keys(stateMap).length > 0) {
            const keyList = [];
            if (stateMap) {
                for (let i in stateMap) {
                    keyList.push(i);
                }
            }
            const module2ConfigMap = {};
            keyList.forEach(key => {
                const innerConfig = switchParamsKey2InnerKey(key);
                if (innerConfig && (innerConfig === null || innerConfig === void 0 ? void 0 : innerConfig.type)) {
                    if (module2ConfigMap[innerConfig === null || innerConfig === void 0 ? void 0 : innerConfig.type]) {
                        module2ConfigMap[innerConfig === null || innerConfig === void 0 ? void 0 : innerConfig.type].push({
                            keyPath: innerConfig === null || innerConfig === void 0 ? void 0 : innerConfig.keyPath,
                            value: stateMap[key],
                        });
                    }
                    else {
                        module2ConfigMap[innerConfig === null || innerConfig === void 0 ? void 0 : innerConfig.type] = [
                            {
                                keyPath: innerConfig === null || innerConfig === void 0 ? void 0 : innerConfig.keyPath,
                                value: stateMap[key],
                            },
                        ];
                    }
                }
            });
            for (let moduleName in module2ConfigMap) {
                if (moduleName === 'mailReducer') {
                    store.dispatch(MailActions.doUpdateStateByURL(module2ConfigMap[moduleName]));
                }
            }
        }
        const task = unifiedInitTask();
        removeKeyFromHistoryState('module');
        if (task) {
            storageApi.putSync(INIT_TASK_KEY, task, { noneUserRelated: true });
            storageApi.putSync(INIT_TASK_TIME_KEY, new Date().getTime() + '', { noneUserRelated: true });
        }
    }
    catch (e) {
        console.warn('[PreSetState Error]', e);
    }
}
storeOpRegister('mail', {
    updateMailModelEntriesFromDb: ev => {
        const { mailReducer } = store.getState();
        const params = ev.eventData;
        const { _account } = ev;
        if ((params === null || params === void 0 ? void 0 : params.checkType) === 'checkCustomerMail') {
        }
        else if ((params === null || params === void 0 ? void 0 : params.checkType) === 'checkSubordinateMail') {
        }
        else {
            store.dispatch(MailActions.doUpdateListIsRefresh(false));
        }
        if (params === null || params === void 0 ? void 0 : params.diff) {
            const forCustomer = (params === null || params === void 0 ? void 0 : params.checkType) === 'checkCustomerMail';
            const forSubordinate = (params === null || params === void 0 ? void 0 : params.checkType) === 'checkSubordinateMail';
            if (forCustomer || forSubordinate) {
                store.dispatch(Thunks.loadMailListFromDB_edm({
                    startIndex: 0,
                    showLoading: false,
                    sliceId: params.sliceId,
                    type: params.type,
                }));
                return;
            }
            const currentFid = mailReducer.selectedKeys.id;
            const currentTag = mailReducer.mailTagFolderActiveKey;
            const isCurrentSelected = (params === null || params === void 0 ? void 0 : params.id) === currentFid;
            const isCurrentAccount = _account == mailReducer.selectedKeys.accountId;
            const isMergeFolder = folderIdIsAllFolder(mailReducer.selectedKeys.id);
            const isTagSelected = currentFid === FLOLDER.TAG &&
                Array.isArray(params === null || params === void 0 ? void 0 : params.tag) &&
                (params === null || params === void 0 ? void 0 : params.tag[0]) === (currentTag === null || currentTag === void 0 ? void 0 : currentTag.key) &&
                accountApi.getIsSameSubAccountSync(_account, (currentTag === null || currentTag === void 0 ? void 0 : currentTag.accountId) || '');
            if (isCurrentAccount && (isCurrentSelected || isTagSelected) && !isMergeFolder) {
                store.dispatch(Thunks.loadMailListFromDB({
                    startIndex: 0,
                    showLoading: false,
                    accountId: _account,
                }));
                return;
            }
            if (folderIdIsAllFolderSubAccount(mailReducer.selectedKeys.id)) {
                store.dispatch(Thunks.loadMailListFromDB({
                    startIndex: 0,
                    showLoading: false,
                    accountId: _account,
                }));
                return;
            }
        }
    },
    updateMailEntities: list => {
        store.dispatch(MailActions.updateMailEntities({
            mailList: list,
        }));
    },
    resetMailWithDraft: ({ cid }) => {
        resetMailWithDraftAsync(cid);
    },
    updateMailEntity: ev => {
        var _a, _b, _c, _d, _e, _f;
        const { _account } = ev;
        if (ev.eventName === 'mailStoreRefresh' && ev.eventStrData === 'mailOp') {
            if (ev.eventData.opType === 'top') {
                if (ev.eventData.status === 'success' || ev.eventData.status === 'fail') {
                    store.dispatch(Thunks.syncMailTop(Object.assign(Object.assign({}, ev), { eventStrData: ev.eventData.opType })));
                }
            }
            if (ev.eventData.opType === 'delete') {
                store.dispatch(Thunks.syncMailDeleted(Object.assign(Object.assign({}, ev), { eventStrData: ev.eventData.opType })));
                if (locationHelper.isReadMail() && ev.eventData.status === 'success') {
                    const mailIds = ev.eventData.params.id;
                    eventApi.sendSysEvent({
                        eventName: 'mailMenuOper',
                        eventStrData: 'closeMailWindow',
                        eventData: mailIds,
                        _account,
                    });
                }
                if ((_b = (_a = ev.eventData) === null || _a === void 0 ? void 0 : _a.params) === null || _b === void 0 ? void 0 : _b.id) {
                    const idList = Array.isArray(ev.eventData.params.id) ? (_d = (_c = ev.eventData) === null || _c === void 0 ? void 0 : _c.params) === null || _d === void 0 ? void 0 : _d.id : [(_f = (_e = ev.eventData) === null || _e === void 0 ? void 0 : _e.params) === null || _f === void 0 ? void 0 : _f.id];
                    store.dispatch(MailTabActions.doBatchCloseTab(idList));
                }
            }
            else if (ev.eventData.opType === 'move') {
                store.dispatch(Thunks.syncMailMove(Object.assign(Object.assign({}, ev), { eventStrData: ev.eventData.opType })));
            }
            else {
                store.dispatch(MailActions.doMailOperation(Object.assign(Object.assign({}, ev), { eventStrData: ev.eventData.opType })));
            }
        }
    },
    updateMailTag: payload => {
        store.dispatch(Thunks.syncMailTagOper(payload));
    },
    updateAiAssistVisiable: () => {
        const { mailReducer } = store.getState();
        store.dispatch(MailActions.doUpdateAiAssistVisiable(!mailReducer.aiAssistSideBarVisiable));
    },
    updateAiAssistVisiable_sd: (payload) => {
        const { mailReducer } = store.getState();
        store.dispatch(MailActions.doUpdateAiAssistVisiable_sd(Object.assign(Object.assign({}, mailReducer.aiAssistSideBarVisiable_sd), { visiable: payload })));
    },
    readMailFromAI: (payload) => {
        const { uid, mid, ownerId, openExtraParams, sourceType } = payload || {};
        const { mailReducer, mailTabReducer } = store.getState();
        if (openExtraParams === null || openExtraParams === void 0 ? void 0 : openExtraParams.isResign) {
            window.open(`${systemApi.getContextPath()}/readMail/?resignMid=${mid}&id=${mid}&resignEmail=${uid}&${openExtraParams.isResign ? '&isResign=1' : ''}`);
            return;
        }
        if (sourceType === 'normal') {
            const mailTabModel = {
                id: mid,
                title: '邮件详情',
                type: tabType.read,
                closeable: true,
                isActive: true,
                extra: {
                    accountId: uid,
                },
            };
            store.dispatch(MailTabActions.doSetTab(mailTabModel));
            return;
        }
        store.dispatch(MailActions.doReadMailFromAI(payload));
        if (mailTabReducer.currentTab.type !== tabType.read && mailTabReducer.currentTab.type !== tabType.subordinate) {
            store.dispatch(MailTabActions.doChangeCurrentTab(tabId.subordinate));
        }
        if (mailReducer.configMailLayout === '2' && mailTabReducer.currentTab.type !== tabType.read) {
            const mailTabModel = {
                id: mid,
                title: '下属AI助理读信邮件',
                type: tabType.read,
                closeable: true,
                isActive: true,
                extra: {
                    from: tabId.subordinate,
                },
            };
            store.dispatch(MailTabActions.doSetTab(mailTabModel));
        }
        else {
            store.dispatch(MailTabActions.doUpdateCMCurrentTab({
                nextMid: mid,
                accountId: uid,
                query: {
                    mid,
                    owner: uid || '',
                    subEmail: uid || '',
                    mailFrom: 'subordinate',
                    colleagueAccId: ownerId + '',
                },
            }));
        }
    },
    openFileFromAI: (payload) => {
        const onList = payload
            .filter(i => i.fileType && IMG_TYPES.includes(i.fileType))
            .map(i => (Object.assign(Object.assign({}, i), { nonOriginal: true, downloadUrl: i.fileUrl, previewUrl: i.filePreviewUrl, name: i.fileName, size: i.fileSize })));
        const start = 0;
        ImgPreview.preview({ data: onList, startIndex: start });
    },
    extractMailFromAI: (payload) => {
        const { gotoSd, searchPayload, list } = payload || {};
        if (!!searchPayload) {
            if (gotoSd) {
                store.dispatch(MailTabActions.doChangeCurrentTab(tabId.subordinate));
            }
            store.dispatch(Thunks.doExtractMailFromAI(payload));
        }
        else if (Array.isArray(list) && !!list.length) {
        }
    },
    async removeMailFromAI(params) {
        const { list, isCompletelyRemove } = params || {};
        const mailMap = {};
        list.forEach(mail => {
            const account = mail.uid || '';
            if (!mailMap[account]) {
                mailMap[account] = [];
            }
            mailMap[account].push(mail.mid);
        });
        await store.dispatch(Thunks.deleteMailMultiAccount({
            map: mailMap,
            directDelete: !!isCompletelyRemove,
        }));
    },
    setMailReadFromAI(params) {
        const { list, status } = params || {};
        const mailMap = {};
        list.forEach(mail => {
            const account = mail.uid || '';
            if (!mailMap[account]) {
                mailMap[account] = [];
            }
            mailMap[account].push(mail.mid);
        });
        eventApi.sendSysEvent({
            eventName: 'mailStatesChanged',
            eventData: {
                mark: status,
                map: mailMap,
            },
            eventStrData: 'bulkRead',
        });
    },
    setMailFlagFromAI(params) {
        const { list, status } = params || {};
        const mailMap = {};
        list.forEach(mail => {
            const account = mail.uid || '';
            if (!mailMap[account]) {
                mailMap[account] = [];
            }
            mailMap[account].push(mail.mid);
        });
        eventApi.sendSysEvent({
            eventName: 'mailStatesChanged',
            eventData: {
                mark: !!status,
                map: mailMap,
            },
            eventStrData: 'bulkMark',
        });
    },
});
try {
    if (inWindow() && window && !window['__getIn18Text']) {
        window['__getIn18Text'] = getIn18Text;
    }
}
catch (e) {
    console.error('[window.__getIn18Text error]', e);
}
try {
    if (inWindow() && window && !window.__sirius_redux_store) {
        window.__sirius_redux_store = {
            store,
            getState: () => {
                return store.getState();
            },
            getMailState: (key) => {
                const state = store.getState().mailReducer;
                if (key) {
                    return state[key];
                }
                return state;
            },
            showMailState: () => {
                const state = store.getState().mailReducer;
                window.console['log']('[mailReducer]', state);
                return state;
            },
            getMailModalById: (id) => {
                if (id) {
                    const state = store.getState().mailReducer;
                    const map = state.mailEntities;
                    return map[id];
                }
            },
            showMailInfo: () => {
                var _a;
                const state = store.getState().mailReducer;
                const data = [
                    { name: '选中文件夹', value: state.selectedKeys },
                    { name: '选中邮件id', value: state.selectedMailId },
                    { name: '选中的邮件model', value: state.mailEntities[(_a = state.selectedMailId) === null || _a === void 0 ? void 0 : _a.id] },
                    { name: '邮件激活id', value: state.activeIds },
                    { name: '账号信息', value: state.mainAccountState },
                    { name: '文件夹信息', value: state.mailTreeStateMap },
                    { name: '子账号信息', value: state.childAccountStateMap },
                    { name: '失效账号列表', value: state.expiredAccountList },
                    { name: '列表二级筛选', value: state.mailListStateTab },
                    { name: '列表到顶部高度-虚拟', value: state.scrollTop },
                    { name: '邮件列表id', value: state.mailDataList },
                    { name: '搜索接过id', value: state.searchList },
                    { name: '邮件列表总数', value: state.mailTotal },
                    { name: '文件夹展开', value: state.expandedSearchKeys },
                    { name: '列表到顶部高度-虚拟', value: state.scrollTop },
                ];
                window.console['table'](data);
                return data;
            },
        };
    }
}
catch (e) {
    console.error('[window.__sirius_redux_store error]', e);
}
try {
    if (inWindow() && window && process.env.NODE_ENV === 'development') {
        class PopupDebugTools {
            getAllPopups() {
                const state = store.getState().popupReducer;
                return {
                    registeredPopups: state.registeredPopUpWinMap,
                    currentShowing: state.currentShowedPopUpWin,
                    lastShown: state.lastShowedPopUpWin,
                    isNewUser: state.showNewUserGuide,
                };
            }
            printStatus() {
                const status = this.getAllPopups();
                console.group('🔍 PopupNotification 状态');
                console.log('所有已注册弹窗:', status.registeredPopups);
                console.log('当前显示的弹窗:', status.currentShowing);
                console.log('上一个显示的弹窗:', status.lastShown);
                console.log('是否为新用户:', status.isNewUser);
                console.groupEnd();
                return status;
            }
            showPopup(winId) {
                if (!winId) {
                    console.error('请提供有效的弹窗ID');
                    return;
                }
                store.dispatch(PopupActions.openOrCloseWin({
                    winId,
                    status: 'OPEN',
                }));
                console.log(`✅ 已尝试打开弹窗: ${winId}`);
                return this.getAllPopups();
            }
            closeCurrentPopup() {
                const state = store.getState().popupReducer;
                const currentPopup = state.currentShowedPopUpWin;
                if (!currentPopup) {
                    console.log('⚠️ 当前没有显示的弹窗');
                    return;
                }
                store.dispatch(PopupActions.openOrCloseWin({
                    winId: currentPopup.id,
                    status: 'CLOSE',
                }));
                console.log(`✅ 已关闭弹窗: ${currentPopup.id}`);
                return this.getAllPopups();
            }
            resetPopupState(winId) {
                const state = store.getState().popupReducer;
                const popup = state.registeredPopUpWinMap[winId];
                if (!popup) {
                    console.error(`⚠️ 找不到ID为 ${winId} 的弹窗`);
                    return;
                }
                const updatedPopup = Object.assign(Object.assign({}, popup), { lastShowTime: null, lastCloseTime: null, setNoShow: false });
                store.dispatch(PopupActions.registerNewWin({
                    type: updatedPopup.type,
                    id: winId,
                    priority: updatedPopup.priority,
                    notShowPeriod: updatedPopup.notShowPeriod,
                    showOnceMoreEachDay: updatedPopup.showOnceMoreEachDay,
                    forModuleId: updatedPopup.forModuleId,
                    forNew: updatedPopup.forNew,
                }));
                console.log(`✅ 已重置弹窗状态: ${winId}`);
                return this.getAllPopups();
            }
            setNewUserStatus(isNew = true) {
                store.dispatch(PopupActions.loadLocalDataAndMerge({
                    data: store.getState().popupReducer.registeredPopUpWinMap,
                    isNewUser: isNew,
                }));
                console.log(`✅ 已设置新用户状态: ${isNew ? '是' : '否'}`);
                return this.getAllPopups();
            }
            showDebugUI() {
                var _a;
                const existingUI = document.getElementById('popup-debug-panel');
                if (existingUI) {
                    document.body.removeChild(existingUI);
                }
                const panel = document.createElement('div');
                panel.id = 'popup-debug-panel';
                panel.style.cssText = `
          position: fixed;
          bottom: 20px;
          right: 20px;
          width: 320px;
          background: #fff;
          border: 1px solid #ccc;
          border-radius: 8px;
          box-shadow: 0 2px 10px rgba(0,0,0,0.2);
          z-index: 9999;
          font-family: Arial, sans-serif;
          overflow: hidden;
        `;
                const header = document.createElement('div');
                header.style.cssText = `
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 10px 15px;
          background: #f0f0f0;
          border-bottom: 1px solid #ddd;
          cursor: move;
        `;
                header.innerHTML = `
          <h3 style="margin: 0; font-size: 14px;">PopupNotification 调试面板</h3>
          <button id="close-debug-panel" style="border: none; background: none; cursor: pointer; font-size: 16px;">×</button>
        `;
                panel.appendChild(header);
                const content = document.createElement('div');
                content.style.cssText = `
          padding: 15px;
          max-height: 400px;
          overflow-y: auto;
        `;
                panel.appendChild(content);
                document.body.appendChild(panel);
                (_a = document.getElementById('close-debug-panel')) === null || _a === void 0 ? void 0 : _a.addEventListener('click', () => {
                    document.body.removeChild(panel);
                });
                const updateStatus = () => {
                    const state = this.getAllPopups();
                    const popupCount = Object.keys(state.registeredPopups).length;
                    let currentPopupInfo = '无';
                    if (state.currentShowing) {
                        currentPopupInfo = `${state.currentShowing.id} (${state.currentShowing.type})`;
                    }
                    content.innerHTML = `
            <div style="margin-bottom: 15px;">
              <div style="margin-bottom: 5px;"><strong>已注册弹窗:</strong> ${popupCount}个</div>
              <div style="margin-bottom: 5px;"><strong>当前显示:</strong> ${currentPopupInfo}</div>
              <div style="margin-bottom: 5px;"><strong>新用户状态:</strong> ${state.isNewUser ? '是' : '否'}</div>
            </div>
            
            <div style="margin-bottom: 15px;">
              <button id="refresh-status" style="margin-right: 10px; padding: 5px 10px;">刷新状态</button>
              <button id="toggle-new-user" style="padding: 5px 10px;">
                ${state.isNewUser ? '设为老用户' : '设为新用户'}
              </button>
            </div>
            
            <div style="margin-bottom: 15px;">
              <h4 style="margin: 10px 0; font-size: 14px;">弹窗操作</h4>

              <button id="close-current" style="padding: 5px 10px;">关闭当前弹窗</button>
            </div>
            
            <div>
              <h4 style="margin: 10px 0; font-size: 14px;">已注册弹窗列表</h4>
              <div id="popup-list" style="max-height: 200px; overflow-y: auto; border: 1px solid #eee; padding: 5px;">
                ${Object.entries(state.registeredPopups)
                        .map(([id, popup]) => `
                  <div style="margin-bottom: 8px; padding: 5px; border-bottom: 1px solid #eee;">
                    <div style="font-size: 12px; margin-bottom: 3px;">
                      <strong>ID:</strong> ${id}
                    </div>
                    <div style="font-size: 12px; margin-bottom: 3px;">
                      <strong>类型:</strong> ${popup.type}
                    </div>
                    <div style="font-size: 12px; display: flex; justify-content: space-between;">
                      <button class="show-popup-btn" data-id="${id}" style="font-size: 11px; padding: 2px 5px;">显示</button>
                      <button class="reset-popup-btn" data-id="${id}" style="font-size: 11px; padding: 2px 5px;">重置状态</button>
                    </div>
                  </div>
                `)
                        .join('')}
              </div>
            </div>
          `;
                    setTimeout(() => {
                        var _a, _b, _c;
                        document.querySelectorAll('.show-popup-btn').forEach(btn => {
                            btn.addEventListener('click', e => {
                                const id = e.target.getAttribute('data-id');
                                if (id) {
                                    this.showPopup(id);
                                    updateStatus();
                                }
                            });
                        });
                        document.querySelectorAll('.reset-popup-btn').forEach(btn => {
                            btn.addEventListener('click', e => {
                                const id = e.target.getAttribute('data-id');
                                if (id) {
                                    this.resetPopupState(id);
                                    updateStatus();
                                }
                            });
                        });
                        (_a = document.getElementById('refresh-status')) === null || _a === void 0 ? void 0 : _a.addEventListener('click', () => {
                            updateStatus();
                        });
                        (_b = document.getElementById('toggle-new-user')) === null || _b === void 0 ? void 0 : _b.addEventListener('click', () => {
                            this.setNewUserStatus(!state.isNewUser);
                            updateStatus();
                        });
                        (_c = document.getElementById('close-current')) === null || _c === void 0 ? void 0 : _c.addEventListener('click', () => {
                            this.closeCurrentPopup();
                            updateStatus();
                        });
                    }, 0);
                };
                updateStatus();
                let isDragging = false;
                let offsetX = 0;
                let offsetY = 0;
                header.addEventListener('mousedown', e => {
                    isDragging = true;
                    offsetX = e.clientX - panel.getBoundingClientRect().left;
                    offsetY = e.clientY - panel.getBoundingClientRect().top;
                });
                document.addEventListener('mousemove', e => {
                    if (isDragging) {
                        panel.style.left = e.clientX - offsetX + 'px';
                        panel.style.top = e.clientY - offsetY + 'px';
                        panel.style.right = 'auto';
                        panel.style.bottom = 'auto';
                    }
                });
                document.addEventListener('mouseup', () => {
                    isDragging = false;
                });
            }
            help() {
                console.group('🔧 PopupNotification 调试工具使用指南');
                console.log('printStatus() - 打印当前弹窗状态');
                console.log('showPopup(winId) - 显示指定ID的弹窗');
                console.log('closeCurrentPopup() - 关闭当前显示的弹窗');
                console.log('resetPopupState(winId) - 重置指定弹窗的状态');
                console.log('setNewUserStatus(isNew) - 设置新用户状态');
                console.log('showDebugUI() - 显示图形界面调试面板');
                console.log('testAll() - 测试所有功能');
                console.groupEnd();
            }
            testAll() {
                console.group('🧪 PopupNotification 功能测试');
                console.log('1. 打印当前状态');
                const status = this.printStatus();
                console.log('2. 获取第一个已注册弹窗');
                const popups = Object.keys(status.registeredPopups);
                const testWinId = popups.length > 0 ? popups[0] : null;
                console.log('3. 显示弹窗');
                setTimeout(() => {
                    if (testWinId) {
                        this.showPopup(testWinId);
                    }
                    else {
                        console.log('没有可用的弹窗');
                    }
                    console.log('4. 3秒后关闭弹窗');
                    setTimeout(() => {
                        this.closeCurrentPopup();
                        console.log('5. 重置弹窗状态');
                        setTimeout(() => {
                            this.resetPopupState(testWinId);
                            console.log('6. 切换新用户状态');
                            setTimeout(() => {
                                const currentStatus = store.getState().popupReducer.showNewUserGuide;
                                this.setNewUserStatus(!currentStatus);
                                console.log('7. 显示调试面板');
                                setTimeout(() => {
                                    this.showDebugUI();
                                    console.log('测试完成！');
                                    console.groupEnd();
                                }, 1000);
                            }, 1000);
                        }, 1000);
                    }, 3000);
                }, 1000);
            }
        }
        window['PopupDebugTools'] = new PopupDebugTools();
        console.log('PopupNotification 调试工具已加载，使用 PopupDebugTools.help() 查看使用说明');
    }
}
catch (e) {
    console.error('[PopupDebugTools error]', e);
}
export default store;
